export default __webpack_public_path__ + "static/media/integral.d6105c26.jpeg";